export function mapAccrual(dto) {
  if (!dto) {
    return null
  }

  const description = String(dto.description ?? '').trim()
  const createdAt = dto.created_at ?? null
  const amount = Number(dto.amount ?? 0)
  const orderId =
    dto.order_id != null && dto.order_id !== '' ? String(dto.order_id) : null
  const id =
    dto.id != null && dto.id !== ''
      ? String(dto.id)
      : orderId || [createdAt, amount, description].filter(Boolean).join('|')

  return {
    id,
    orderId,
    description,
    amount: Number.isFinite(amount) ? Math.max(0, amount) : 0,
    currency: dto.currency ?? 'VND',
    createdAt,
  }
}

export function mapAccrualList(dtos) {
  if (!Array.isArray(dtos)) {
    return []
  }
  return dtos.map(mapAccrual).filter(Boolean)
}

export function mapFinanceSummary(dto, { total: totalHint } = {}) {
  if (!dto) {
    return {
      balance: 0,
      currency: 'VND',
      balanceAvailable: true,
      accruals: [],
      total: 0,
    }
  }

  const accruals = mapAccrualList(dto.accruals)
  const total = Number(totalHint ?? dto.total) || 0
  const balanceAvailable =
    dto.balance_available == null ? true : Boolean(dto.balance_available)

  return {
    balance: Number(dto.balance ?? 0) || 0,
    currency: dto.currency ?? 'VND',
    balanceAvailable,
    accruals,
    total,
  }
}
